import { TiptapMarkType } from '../tiptapTypes';
import type { TiptapContentMark } from '../tiptapTypes';

const TEXT_COLOR_STYLE_PREFIX = 'TEXT-';
const BACKGROUND_COLOR_STYLE_PREFIX = 'BG-';

const upperStyle = (mark: TiptapContentMark) => mark.type?.toUpperCase() || '';

const styleConverters: Record<string, (mark: TiptapContentMark) => string> = {
    bold: upperStyle,
    italic: upperStyle,
    underline: upperStyle,
    code: upperStyle,
    strike: () => 'STRIKETHROUGH',
    textStyle: (mark) => `TEXT-${mark.attrs?.color}`,
    highlight: (mark) => (mark.attrs?.color === 'darkgrey' ? 'BG-dark-grey' : `BG-${mark.attrs?.color}`),
};

const markTypesByInlineStyle: Record<string, TiptapMarkType> = {
    BOLD: TiptapMarkType.bold,
    ITALIC: TiptapMarkType.italic,
    UNDERLINE: TiptapMarkType.underline,
    CODE: TiptapMarkType.code,
    STRIKETHROUGH: TiptapMarkType.strike,
};

/**
 * Converts a Tiptap mark to the table inline-style vocabulary.
 */
export const convertTiptapMarkToInlineStyle = (mark: TiptapContentMark): string | undefined => {
    const converter = styleConverters[mark.type || ''];
    return converter?.(mark);
};

/**
 * Converts a table inline-style string into the equivalent Tiptap mark.
 */
export const convertInlineStyleToTiptapMark = (style: string): TiptapContentMark | undefined => {
    if (style.startsWith(TEXT_COLOR_STYLE_PREFIX)) {
        return {
            type: TiptapMarkType.textStyle,
            attrs: { color: style.replace(TEXT_COLOR_STYLE_PREFIX, '') },
        };
    }

    if (style.startsWith(BACKGROUND_COLOR_STYLE_PREFIX)) {
        return {
            type: TiptapMarkType.highlight,
            attrs: { color: style.replace(BACKGROUND_COLOR_STYLE_PREFIX, '').replace('-', '') },
        };
    }

    const markType = markTypesByInlineStyle[style];
    return markType ? { type: markType } : undefined;
};
